<template>
  <v-ons-page>
    <div class="sticky1">
      <v-ons-list>
        <v-ons-list-item style="font-size: 0.8em">
          <div class="center">
          </div>
          <div class="right">
            <v-ons-button @click="checkToProceed()" modifier="quiet"><v-ons-icon icon="fa-plus"></v-ons-icon></v-ons-button>
          </div>
        </v-ons-list-item>
      </v-ons-list>
    </div>

    <div class="bodycontent">
      <div v-show="loading">
        <p style="text-align: center; z-index: 9999;">
          <v-ons-progress-bar indeterminate></v-ons-progress-bar>
        </p>
      </div>

      <v-ons-list v-show="readyToShow">
        <div v-for="(item, index) in messages" :key="index" @click="showItem(item)">
          <v-ons-list-item tappable>
            <div class="left">
              <span v-show="item.type === 'email'"><v-ons-icon style="color: #4EBFE9" size="20px" icon="fa-envelope"></v-ons-icon></span>
              <span v-show="item.type === 'twitter'"><v-ons-icon style="color: #4EBFE9" size="20px" icon="fa-twitter"></v-ons-icon></span>
              <!-- <span v-else><v-ons-icon style="color: red;" size="10px" icon="fa-circle"></v-ons-icon></span> -->
            </div>
            <div class="center">
              <span v-show="item.type === 'email'" class="list-item__title" style="font-size: 0.9em;">{{ item.title }}</span>
              <span v-show="item.type === 'twitter'" class="list-item__title" style="font-size: 0.9em;">{{ item.content }}</span>
              <span class="list-item__subtitle" style="font-size: 0.7em;">ステータス：
                <span v-show="item.isValid" style="color: lightgreen;">お預かり中</span>
                <span v-show="item.isValid === false" style="color: darkgrey;">送信済み</span>
                　送信指定日：{{item.targetDate}}
              </span>
            </div>
            <div class="right">
              <span class="list-item__subtitle" style="font-size: 0.6em">
                {{ item.timeStamp | unixTime2ymdDay }}
              </span>
            </div>
          </v-ons-list-item>
        </div>
      </v-ons-list>
      <v-ons-list-item modifier="nodivider" v-show="messages.length === 0">
        <div class="center">新着投稿はありません。</div>
      </v-ons-list-item>

    </div>

  </v-ons-page>
</template>

<script>
import firebase from 'firebase'
import common from '../util/common'
import comLic from '../util/com_license'

export default {
  name: 'ScheduledRoot',
  mixins: [common, comLic],
  data () {
    return {
      componentName: 'ScheduledRoot',
      category: 'scheduled',
      msg: '送信日指定メッセージ',
      readyToShow: false,
      next: { link: 'MsgCreate', anim: 'slide' },
      messages: [],
      loading: false
    }
  },

  created () {
    this.getScheduledMessages()
  },

  mounted () {
  },

  // watch: {
  // },

  methods: {
    getScheduledMessages () {
      const self = this
      const messagesRef = firebase.firestore().collection('/scheduled').where('userId', '==', this.user.userId)

      this.readyToShow = false

      console.log('getScheduledMessages')
      // lastUpdate以降のtimeStampの投稿をごそっと全部取ってくる。
      messagesRef.get()
        .then(snapshot => {
          let recv = []
          if (snapshot.size > 0) {
            for (let i = 0; i < snapshot.size; i++) {
              recv[i] = snapshot.docs[i].data()
            }
            // self.saveItemsToCache()
            self.messages = self.sortDecendingByTimeStamp(recv)
          }
        })
        .then(function () {
          self.readyToShow = true
          self.loading = false
        })
        .catch(err => {
          console.log('Error Get ', this.category, err)
          self.$ons.notification.alert('エラー！通信が安定しているところで再度試してください。')
          self.loading = false
        })
    },

    checkToProceed: async function () {
      let promise = []
      promise.push(this.checkLicense('scheduled'))
      await Promise.all(promise).then((chk) => {
        if (chk[0]) {
          this.goToMode('MsgCreate', 'create', 'scheduled')
        }
      })
    },

    showItem: async function (item) {
      const self = this
      let promise = []
      promise.push(this.checkLicenseDue())
      await Promise.all(promise).then((chk) => {
        self.$store.commit('routerAnim/set', 'slide')
        self.$router.push({name: 'MsgCreate', params: {item: item, mode: 'edit', serviceType: 'scheduled', due: chk[0]}})
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../src/assets/css/miley.css";
</style>



// WEBPACK FOOTER //
// src/components/ScheduledRoot.vue